import React from 'react';
import { StyletronComponent } from 'styletron-react';
import { styled } from '../../Themes';
import { getBaseCustomProps, getFormCustomProps } from '../../Utilities/types/SharedProps';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { MIcon } from '../Icon';
import { PanelContainerStyles, panelContentStyles, panelHeaderStyles } from './styles';
import { IDummyProps } from './types';
import { useUID } from 'react-uid';
import * as meta from '../../meta-data.json';

export const PanelOverrides = (props: IDummyProps) => {
	const HTMLAttrs = getHTMLAttributes(props);

	const StyledIconOverrides: StyletronComponent<any> = styled('div', ({ $theme }: any) => {
		return {
			marginRight: $theme.panel.panelHeaderIconMarginRight,
		};
	});

	const StyledMIcon: StyletronComponent<any> = styled(MIcon, () => {
		return {
			verticalAlign: 'bottom',
		};
	});

	const uniqueIdHeader = `panel-header-${useUID()}`;
	const uniqueIdContent = `panel-content-${useUID()}`;

	return {
		PanelContainer: {
			...PanelContainerStyles(props),
			props: {
				'data-epo': `epo-panel-${meta.version}`,
				part: `epo-panel-${meta.version}`,
				$as: props.accordionList ? 'li' : 'div',
				id: props.id,
				...HTMLAttrs.dataProps,
				className: props.className,
				...getBaseCustomProps(props),
			},
		},

		Header: {
			...(panelHeaderStyles(props, HTMLAttrs) as object),
			props: {
				'data-epo': `epo-panel-${meta.version}`,
				'data-subcomponent': 'panel-header',
				part: `epo-panel-${meta.version}`,
				...HTMLAttrs.ariaProps,
				...getFormCustomProps(props),
				id: uniqueIdHeader,
				'aria-controls': uniqueIdContent,
				tabIndex: props.tabIndex || 0,
				...props['header-props'],
			},
		},
		ToggleIcon: {
			component: ({ $expanded }: any) => {
				return (
					<StyledIconOverrides>
						<StyledMIcon
							icon={$expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}
							aria-hidden="true"
						/>
					</StyledIconOverrides>
				);
			},
		},
		Content: {
			...panelContentStyles(props),
			props: {
				'data-epo': `epo-panel-${meta.version}`,
				part: `epo-panel-${meta.version}`,
				id: uniqueIdContent,
				'aria-labelledby': uniqueIdHeader,
				$as: 'section',
			},
		},
		ContentAnimationContainer: {
			style: {
				transitionDuration: '0ms',
			},
		},
	};
};
